import './count-tooltip.scss';
import Tooltip from '../v2/ui-elements/Tooltip';

function CountTooltip({
  labels,
  showFirst = true,
  isDs = false,
  customTooltipClassName = '',
  customTooltipItemClassName = '',
}) {
  if (!labels || !labels.length) return '-';

  return (
    <div>
      {showFirst && !isDs ? labels[0] : null}

      {labels.length > 1 ? (
        <Tooltip
         isIcon={true}
          title={
            <div className={`CountTooltip__Content ${customTooltipClassName} `}>
              {labels?.slice(1)?.map(label => (
                <div className={`CountTooltip__Item ${customTooltipItemClassName}`} key={label}>
                  {label}
                </div>
              ))}
            </div>
          }
          arrow>
          {showFirst || isDs ? (
            <span className="CountTooltip__CountContainer"> +{labels.length - 1}</span>
          ) : (
            <span className="CountTooltip__CountContainer"> {labels.length}</span>
          )}
        </Tooltip>
      ) : null}
    </div>
  );
}

export default CountTooltip;
